export default __webpack_public_path__ + "static/media/delivery_offer-removebg-preview.b776921a.png";